import { render } from "./text-image.vue?vue&type=template&id=1fedbc9e"
import script from "./text-image.vue?vue&type=script&lang=js"
export * from "./text-image.vue?vue&type=script&lang=js"

import "./text-image.vue?vue&type=style&index=0&id=1fedbc9e&lang=scss"
script.render = render

export default script